import { Button, Flex, Tooltip } from '@aloft/toolkit-sui';

import { resolveFeatureGridFieldConflicts } from '../../../redux/features/actions/resolveFeatureGridFieldConflicts.ts';
import { selectFeatureGridActiveConflictedFields } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';

export const VerifyAllFeaturesButton = () => {
  const dispatch = useAppDispatch();

  const conflictedFields = useAppSelector(selectFeatureGridActiveConflictedFields);

  const isDisabled = Object.keys(conflictedFields).length === 0;

  const tooltipLabel = isDisabled
    ? 'All data conflicts have been resolved!'
    : 'Verify All Features';

  return (
    <Tooltip label={tooltipLabel}>
      <Flex alignItems="center">
        <Button
          disabled={isDisabled}
          variant="secondary"
          size="sm"
          icon="check"
          text="Verify All Features"
          onClick={() => {
            dispatch(resolveFeatureGridFieldConflicts(conflictedFields));
          }}
        />
      </Flex>
    </Tooltip>
  );
};
